import React from 'react'
import {broadcast, listen, stop_listen} from '../../utils'
import './index.css'

class TilesTool extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      mode: 'cursor',
      mouse_down_coords: false,
      container_mouse_coords: false,
      top: 10,
      left: 30,
      tile_links: [],
      user_id: false,
      hidden: false,
      common_hidden: false,
      listners: []
    }
  }

  componentDidMount(){
    const listners = [
      {type: "containter_onMouseMove", fnc: ({detail}) => {
        this.setState({container_mouse_coords: [detail.clientX, detail.clientY]})
        if (!!this.state.mouse_down_coords)
          this.setState({
            top: this.state.top + (detail.clientY - this.state.mouse_down_coords[1]),
            left: this.state.left + (detail.clientX - this.state.mouse_down_coords[0]),
            mouse_down_coords: [detail.clientX, detail.clientY]
          })
      }},
      {type: "toolbar_mode_change", fnc: ({detail}) => this.setState({mode: detail.mode})},
      {type: "map_tile_links", fnc: ({detail}) => this.setState({tile_links: detail})},

      {type: "point_icon", fnc: ({detail}) => this.setState({point_settings: {...this.state.point_settings, icon: detail.value}})},
      {type: "point_size", fnc: ({detail}) => this.setState({point_settings: {...this.state.point_settings, size: detail.value}})},

      {type: "update_point_icon", fnc: ({detail}) => this.setState({point_settings: {...this.state.point_settings, icon: detail.value}})},
      {type: "update_point_size", fnc: ({detail}) => this.setState({point_settings: {...this.state.point_settings, size: detail.value}})},
    ]

    listners.forEach(l => listen(l.type, l.fnc))
    this.setState({listners})
  }

  componentWillUnmount(){this.state.listners.forEach(l => stop_listen(l.type, l.fnc))}

  render() {
    if (this.state.mode === 'tiles'){
      return(
        <div className="polygon-tool" style={{top: this.state.top, left: this.state.left}}>
          <div
            className="tool-header"
            onMouseDown={e => this.setState({mouse_down_coords: this.state.container_mouse_coords})}
            onMouseUp={e => this.setState({mouse_down_coords: false})}
          >
            <span className="tool-header-title">&nbsp;выбор картоосновы</span>
            <div className="tool-header-btns">
              <span
                className="tool-header-btn"
                style={{transform: `rotateZ(0deg)`}}
                onClick={() => {
                  const new_tile = {title: "название", styles_json_url: "ссылка", selected: false}
                  const tile_links = [...this.state.tile_links, new_tile]
                  broadcast("send_map_tile_links", tile_links)
                  this.setState({tile_links: tile_links})
                }}
              >+</span>
              <span
                className="tool-header-btn"
                onClick={() => this.setState({hidden: !this.state.hidden})}
              >{this.state.hidden ? "▾" : "▸"}</span>
              <span
                className="tool-header-btn"
                style={{transform: `rotateZ(45deg)`}}
                onClick={() => broadcast("toolbar_mode_change", {mode: 'cursor'})}
              >+</span>
            </div>
          </div>
          {
            this.state.hidden ? null :
            <div className="tool-body">
              {
                this.state.tile_links.map((v, i) => {
                  if (i === 0){
                    return(
                      <div key={`${i}_tile_link`} style={{borderTop: `0px solid black`}}>
                        <div className="tool-input-cont">
                          <span className="tool-input-label"><b>{v.title}</b>|{v.styles_json_url.slice(0,20)}...</span>
                        </div>
                        <div className="tool-input-cont">
                          <span className="tool-input-label">выбрать</span>
                          <input
                            type="checkbox"
                            className="tool-input"
                            style={{width: "60%"}}
                            checked={v.selected}
                            onChange={e => {
                              const i_select = v.selected ? 0 : i
                              const tile_links = this.state.tile_links.map((vv, ii) => {
                                return({...vv, selected: ii === i_select})
                              })

                              broadcast("map_tile_links", tile_links)
                              broadcast("send_map_tile_links", tile_links)
                              this.setState({tile_links: tile_links})
                            }}
                          />
                        </div>
                      </div>
                    )
                  } else {
                    return(
                      <div key={`${i}_tile_link`} style={{borderTop: `1px solid black`}}>
                        <div className="tool-input-cont">
                          <span className="tool-input-label">название</span>
                          <input
                            className="tool-input"
                            style={{width: "60%"}}
                            value={v.title}
                            onChange={e => {
                              const tile_links = this.state.tile_links.map((vv, ii) =>
                                ii === i ? {...vv, title: e.currentTarget.value} : vv
                              )
                              broadcast("send_map_tile_links", tile_links)
                              this.setState({tile_links: tile_links})
                            }}
                          />
                        </div>

                        <div className="tool-input-cont">
                          <span className="tool-input-label">ссылка</span>
                          <input
                            className="tool-input"
                            style={{width: "60%"}}
                            value={v.styles_json_url}
                            onChange={e => {
                              const tile_links = this.state.tile_links.map((vv, ii) =>
                                ii === i ? {...vv, styles_json_url: e.currentTarget.value} : vv
                              )

                              broadcast("map_tile_links", tile_links)
                              broadcast("send_map_tile_links", tile_links)
                              this.setState({tile_links: tile_links})
                            }}
                          />
                        </div>

                        <div className="tool-input-cont">
                          <span className="tool-input-label">выбрать</span>
                          <input
                            type="checkbox"
                            className="tool-input"
                            style={{width: "60%"}}
                            checked={v.selected}
                            onChange={e => {
                              const i_select = v.selected ? 0 : i
                              const tile_links = this.state.tile_links.map((vv, ii) => {
                                return({...vv, selected: ii === i_select})
                              })

                              broadcast("map_tile_links", tile_links)
                              broadcast("send_map_tile_links", tile_links)
                              this.setState({tile_links: tile_links})
                            }}
                          />
                        </div>
                        <div className="tool-input-cont">
                          <span
                            onClick={() => {
                              const tile_links = this.state.tile_links.filter((vv, ii) => ii !== i)
                              broadcast("send_map_tile_links", tile_links)
                              this.setState({tile_links: tile_links})
                            }}
                            className="tool-input-button"
                            style={{color: "red"}}
                          >удалить</span>
                        </div>
                      </div>
                    )
                  }
                })
              }
            </div>
          }
        </div>
      )
    } else {
      return(null)
    }
  }
}

export default TilesTool;
